(ns com.theplantscape.plant-web.components.tailwind.buttons
  (:require [cljs.core.async :refer [<! go]]
            [reagent.core :as r]))

(defn button
  ([content] (button nil content))
  ([data content] 
   [:button.px-6.py-2.rounded.bg-emerald-400.hover:bg-emerald-500.text-emerald-100 data content]))

(defn button-progress [data content]
  (let [in-progress (r/atom false)]
    (fn [data content]
      [:button.px-6.py-2.rounded.bg-emerald-400.hover:bg-emerald-500.text-emerald-100
       {:on-click #()}
       (merge )
       data
       [:span [:i.fas.fa-circle-notch {:class (when @in-progress "fa-spin")}]]
       content])))

(defn button-progress-ajax
  [text {:keys [on-click on-complete] :as actions}]
  (let [in-progress (r/atom false)]
    (fn [text actions]
      [:button.px-6.py-2.rounded.bg-emerald-400.hover:bg-emerald-500.text-emerald-100
       {:on-click (fn [evt]
                    (.preventDefault evt)
                    (reset! in-progress true)
                    (on-click
                     (fn [data]
                       (when (:on-complete actions)
                         ((:on-complete actions) data))
                       (reset! in-progress false))))}
       (when @in-progress
         [:span [:i.fas.fa-circle-notch {:class "fa-spin" #_(when @in-progress "fa-spin")}]])
       text])))


(defn button-progress-async
  [text {:keys [on-click on-complete] :as actions}]
  (let [in-progress (r/atom false)
        response (r/atom nil)]
    (fn [text actions]
      [:button.pr-6.pl-2.py-2.rounded.bg-emerald-400.hover:bg-emerald-500.text-emerald-100
       {:on-click (fn [evt]
                    (.preventDefault evt)
                    (.stopPropagation evt)
                    (reset! in-progress true)
                    (go
                      (reset! response (<! (on-click)))
                      (when on-complete (on-complete @response))
                      (reset! in-progress false)))}
       [:span [:i.fas.fa-circle-notch.fa-spin {:class (str "fa-spin " (when (false?  @in-progress) "invisible"))}]]
       text])))


(defn button-toggle [state update-fn]
  [:button.px-6.py-2.rounded.bg-emerald-400.hover:bg-emerald-500.text-emerald-100
   {:on-click update-fn}
   [:div.rounded-full]])
